export const environment = {
  production: true,

  serviceProviderAccountEndpoint: '/smapi',
  serviceProviderEndpointAuthMethod: 'basic',

  enterpriseAccountEndpoint: 'http://18.197.14.241:8485',
  enterpriseAccountEndpointAuthMethod: 'jwt',

  importFileEndpoint: '/api3',

  // REQUIRED - Amazon Cognito Region
  region: 'eu-west-1',
  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: 'eu-west-1_5uRVGc2sp',
  // OPTIONAL - Amazon Cognito Web Client ID
  userPoolWebClientId: '3co9e9qftsag3ji4ufam9v19tt',

  mainPageRefreshInterval: 15000,

  errorMessageDuration: 2000,
  theme: 'achelos'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts